import type { Config } from './types'


export default (window.__CONFIG__) as Config
